interface MaintenanceRequestFeedbackProps {
  feedback: string;
}

const MaintenanceRequestFeedback = ({ feedback }: MaintenanceRequestFeedbackProps) => {
  if (feedback) {
    return (
      <div className="w-100%">
        <span style={styles.title}>Feedback</span>
        <div className="mt-5 ph-1">
          {feedback.split(/\r?\n/).map((val, key) => {
            return (
              <>
                <div key={`feedback-${key}`}>{val}</div>
                <br />
              </>
            );
          })}
        </div>
      </div>
    );
  }
  return null;
};

export default MaintenanceRequestFeedback;

const styles = {
  title: {
    fontWeight: '600',
    fontSize: 16,
    color: 'black',
  },
};
